import React from "react";
import logo from "../assets/images/Company-Logo.png";
import googlePlayBadge from '../assets/images/Company-Logo.png';
import { NavLink } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-6 py-16">
        
        {/* Main Footer Grid */}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          
          {/* Company Info Section */}
          <div className="md:col-span-4">
            <NavLink to="/" className="inline-block group">
              <img
                src={logo}
                alt="EMS Logo"
                className="h-12 w-auto object-contain transition-transform duration-300 group-hover:scale-105"
              />
            </NavLink>
            <p className="mt-6 text-sm leading-relaxed text-gray-400">
              Complete Employee Management System powered by AI. Streamline your HR operations,
              automate payroll, track attendance, and manage your workforce efficiently from one unified platform.
            </p>
            
            {/* Trust Badge */}
            {/* <div className="mt-4 flex items-center gap-3">
              <div className="flex -space-x-2">
                <div className="w-8 h-8 rounded-full bg-blue-500 flex items-center justify-center text-xs font-bold text-white border-2 border-gray-800">1000+</div>
              </div>
              <span className="text-xs text-gray-400">Businesses trust us</span>
            </div> */}
          </div>

          {/* Quick Links */}
          <div className="md:col-span-2">
            <h6 className="text-sm font-semibold text-white mb-4">Product</h6>
            <ul className="space-y-2 text-sm">
              <li>
                <NavLink 
                  to="/employee-management" 
                  className={({ isActive }) => 
                    `transition-colors duration-300 ${isActive ? 'text-blue-400' : 'hover:text-blue-400'}`
                  }
                >
                  Employee Management
                </NavLink>
              </li>
              <li>
                <NavLink 
                  to="/attendance" 
                  className={({ isActive }) => 
                    `transition-colors duration-300 ${isActive ? 'text-blue-400' : 'hover:text-blue-400'}`
                  }
                >
                  Attendance Tracking
                </NavLink>
              </li>
              <li>
                <NavLink 
                  to="/payroll" 
                  className={({ isActive }) => 
                    `transition-colors duration-300 ${isActive ? 'text-blue-400' : 'hover:text-blue-400'}`
                  }
                >
                  Payroll Management
                </NavLink>
              </li>
              <li>
                <NavLink 
                  to="/performance" 
                  className={({ isActive }) => 
                    `transition-colors duration-300 ${isActive ? 'text-blue-400' : 'hover:text-blue-400'}`
                  }
                >
                  Performance Reviews
                </NavLink>
              </li>
              <li>
                <NavLink 
                  to="/pricing" 
                  className={({ isActive }) => 
                    `transition-colors duration-300 ${isActive ? 'text-blue-400' : 'hover:text-blue-400'}`
                  }
                >
                  Pricing Plans
                </NavLink>
              </li>
            </ul>
          </div>

          {/* Company Links */}
          <div className="md:col-span-2">
            <h6 className="text-sm font-semibold text-white mb-4">Company</h6>
            <ul className="space-y-2 text-sm">
              <li>
                <NavLink 
                  to="/aboutus" 
                  className={({ isActive }) => 
                    `transition-colors duration-300 ${isActive ? 'text-blue-400' : 'hover:text-blue-400'}`
                  }
                >
                  About Us
                </NavLink>
              </li>
              <li>
                <NavLink 
                  to="/blog" 
                  className={({ isActive }) => 
                    `transition-colors duration-300 ${isActive ? 'text-blue-400' : 'hover:text-blue-400'}`
                  }
                >
                  Blog
                </NavLink>
              </li>
              <li>
              
              </li>
              <li>
                <NavLink 
                  to="/contact" 
                  className={({ isActive }) => 
                    `transition-colors duration-300 ${isActive ? 'text-blue-400' : 'hover:text-blue-400'}`
                  }
                >
                  Contact Us
                </NavLink>
              </li>
            </ul>
          </div>

          {/* Resources & Support */}
          <div className="md:col-span-2">
            <h6 className="text-sm font-semibold text-white mb-4">Resources</h6>
            <ul className="space-y-2 text-sm">
              <li>
                <NavLink 
                  to="/help" 
                  className={({ isActive }) => 
                    `transition-colors duration-300 ${isActive ? 'text-blue-400' : 'hover:text-blue-400'}`
                  }
                >
                  Help Center
                </NavLink>
              </li>
              <li>
                <NavLink 
                  to="/privacypolicy" 
                  className={({ isActive }) => 
                    `transition-colors duration-300 ${isActive ? 'text-blue-400' : 'hover:text-blue-400'}`
                  }
                >
                  Privacy Policy
                </NavLink>
              </li>
              <li>
                <NavLink 
                  to="/termsandconditions" 
                  className={({ isActive }) => 
                    `transition-colors duration-300 ${isActive ? 'text-blue-400' : 'hover:text-blue-400'}`
                  }
                >
                  Terms & Conditions
                </NavLink>
              </li>
              <li>
                <NavLink 
                  to="/faq" 
                  className={({ isActive }) => 
                    `transition-colors duration-300 ${isActive ? 'text-blue-400' : 'hover:text-blue-400'}`
                  }
                >
                  FAQ
                </NavLink>
              </li>
            </ul>
          </div>

          {/* App Download & Social */}
          <div className="md:col-span-2">
            <h6 className="text-sm font-semibold text-white mb-4">Get the App</h6>
            
            {/* App Download */}
           

            {/* OpenBook Button */}
          

            {/* Social Links */}
            <h6 className="text-sm font-semibold text-white mb-3">Follow Us</h6>
            <div className="flex gap-4">
              <a 
                href="https://www.instagram.com/ai.zops/"
                target="_blank" 
                rel="noreferrer" 
                className="text-gray-400 hover:text-pink-500 transition-all duration-300 hover:scale-110"
                aria-label="Instagram"
              >
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 7a5 5 0 100 10 5 5 0 000-10z"/>
                </svg>
              </a>
              <a 
                href="https://www.facebook.com/ai.zops/"
                target="_blank" 
                rel="noreferrer" 
                className="text-gray-400 hover:text-blue-600 transition-all duration-300 hover:scale-110"
                aria-label="Facebook"
              >
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                </svg>
              </a>
              <a 
                href="https://x.com/ai_zops/" 
                target="_blank" 
                rel="noreferrer" 
                className="text-gray-400 hover:text-white transition-all duration-300 hover:scale-110"
                aria-label="Twitter"
              >
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231z"/>
                </svg>
              </a>
              <a 
                href="https://www.linkedin.com/company/aizops/"
                target="_blank" 
                rel="noreferrer" 
                className="text-gray-400 hover:text-blue-700 transition-all duration-300 hover:scale-110"
                aria-label="LinkedIn"
              >
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451c.979 0 1.771-.773 1.771-1.729V1.729C24 .774 23.204 0 22.225 0z"/>
                </svg>
              </a>
              <a 
                href="https://www.youtube.com/@AIZOPS/" 
                target="_blank" 
                rel="noreferrer" 
                className="text-gray-400 hover:text-red-600 transition-all duration-300 hover:scale-110"
                aria-label="YouTube"
              >
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
                </svg>
              </a>
            </div>

            {/* Contact Info */}
            <div className="mt-6 pt-4 border-t border-gray-700">
              <p className="text-xs text-gray-400 mb-1">📧 support@aizops.com</p>
              <p className="text-xs text-gray-400">📞 91 9046373358</p>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-700 mt-12 pt-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-gray-500">
            <p>© 2025 AIZOPS. All rights reserved.</p>
            <div className="flex gap-6">
              <NavLink to="/sitemap" className="hover:text-blue-400 transition-colors text-xs">Sitemap</NavLink>
              <NavLink to="/accessibility" className="hover:text-blue-400 transition-colors text-xs">Accessibility</NavLink>
              <NavLink to="/cookies" className="hover:text-blue-400 transition-colors text-xs">Cookie Policy</NavLink>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
} 